import { css } from '@emotion/css';
import React from 'react';
import { FadeInImage } from 'src/components/shared/FadeInImage';
import { HomeResident } from 'src/models/resort/HomeResident';

interface NpcIconsProps {
  npcs: HomeResident[];
  iconSize: number;
}

export const NpcIcons = ({ npcs, iconSize }: NpcIconsProps) => {
  return (
    <div
      className={css`
        img {
          display: inline-block;
          width: ${iconSize}px;
          height: ${iconSize}px;
          margin: 0 auto;
        }
      `}
    >
      {npcs.map(npc => (
        <FadeInImage key={npc.name} src={npc.image} width={256} height={256} />
      ))}
    </div>
  );
};
